import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import BlockIcon from '@material-ui/icons/Block';
import useTheme from '@material-ui/styles/useTheme';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { blockUserAction } from 'store/conference/conferenceActions';

BlockUserIcon.propTypes = {
  questionUserId: PropTypes.string.isRequired,
  setShowSpinner: PropTypes.func.isRequired,
};
let blockUserText =
  ' By Clicking Block User, This User Will No Longer Be Able To Ask Questions For This Session Only.';

let unblockUserText =
  'By Clicking Unblock User, This User Will Be Permitted To Ask Questions For The Rest Of The Session';
export default function BlockUserIcon({ questionUserId, setShowSpinner }) {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const { userIsBlocked } = useSelector(({ conference }) => ({
    userIsBlocked: (conference.blockedUsers || []).includes(questionUserId),
  }));

  const [shouldBlock, setShouldBlock] = React.useState(!userIsBlocked);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {shouldBlock ? `Block User` : 'Unblock User'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {shouldBlock ? blockUserText : unblockUserText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setShowSpinner({ show: true, type: 'block' });
              setTimeout(() => {
                try {
                  setShowSpinner({ show: false, type: '' });
                } catch (e) {
                  console.log('');
                }
              }, 20000);
              dispatch(blockUserAction({ BlockUserId: questionUserId, shouldBlock }));
              handleClose();
            }}
            style={{ backgroundColor: theme.palette.danger.main, color: 'white' }}
            autoFocus
          >
            {shouldBlock ? `Block User` : 'Unblock User'}
          </Button>
        </DialogActions>
      </Dialog>

      {userIsBlocked ? (
        <IconButton
          aria-label="unblock user"
          onClick={() => {
            setShouldBlock(false);
            handleClickOpen();
          }}
        >
          <PersonAddIcon style={{ color: theme.palette.danger.main }} />
        </IconButton>
      ) : (
        <IconButton
          aria-label="block user"
          onClick={() => {
            setShouldBlock(true);
            handleClickOpen();
          }}
        >
          <BlockIcon style={{ color: theme.palette.danger.main }} />
        </IconButton>
      )}
    </>
  );
}
